import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Package, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-24" data-testid="not-found-page">
      <SEO
        title="Sidan hittades inte (404)"
        description="Sidan du letar efter finns inte längre eller har flyttats."
        noindex={true}
      />
      <div className="text-center max-w-lg">
        <p className="text-7xl font-bold text-[#321a27] mb-4">404</p>
        <h1 className="text-2xl font-semibold text-gray-900 mb-3">Sidan hittades inte</h1>
        <p className="text-gray-600 mb-8">
          Sidan du letar efter finns inte längre, har flyttats eller så är adressen felstavad.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#321a27] text-white rounded-lg hover:bg-[#4a2739] transition-colors"
          >
            <Home className="w-4 h-4" /> Till startsidan
          </Link>
          <Link
            to="/produkter"
            data-testid="not-found-products-link"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-[#321a27] text-[#321a27] rounded-lg hover:bg-gray-50 transition-colors"
          >
            <Package className="w-4 h-4" /> Se våra produkter <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
